/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Ornate_Goose_SkipInputs */

const fr_plain_ornate_goose_skip = /** @type {(inputs: Plain_Ornate_Goose_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1 mois`)
};

/**

* @param {Plain_Ornate_Goose_SkipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plain_ornate_goose_skip = /** @type {((inputs?: Plain_Ornate_Goose_SkipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Ornate_Goose_SkipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plain_ornate_goose_skip(inputs)
});